<template>
		<div>
			<main style='background: #DDEAFB;'>
				<div class="fyBox">
					<!-- <div class="centerBox">
						<img src="../../assets/images/wuzheng_banner.png" alt="" class="topImg">
					</div> -->
				</div>
				<div class="topContent">
					<div class="centerBox">
						<p class="topContent_word1">物证鉴定</p>
						<p class="topContent_word2">        物证鉴定，是指诉讼中用自然科学的原理和技术方法对与案件有关的物证材料进行鉴别和判断的活动。其结论为案件的证据。包括刑事、民事案件以及民事纠纷中涉及的一切物质和痕迹的鉴定。物质、痕迹种类很多。鉴定可按被鉴定物种属分类，如纤维鉴定、药物鉴定等；也可按所属学科分类，如司法化学鉴定、司法物理鉴定等；通过鉴定确认被鉴定物的种类，来源，是否来自苯一客体；痕迹形成的原因、条件，由何种客体形成，是否某一特定客体所形成等。</p>
					</div>
				</div>
				<div class="centerBox" style="padding:26px 0;">
					<p class="topContent_word1">鉴定机构列表</p>
					<div class="bottomContent">
						<div class="bottomContent_top">
							<a href="http://www.yanzhaosifa.com/"><img src="../../assets/images/wuzheng_logo.jpg" alt=""></a>

								<p class="bottomContent_topWord">
								燕赵司法鉴定中心是经河北省司法厅核准设立的交通事故痕迹物证司法鉴定机构，鉴定业务范围包括：交通事故痕迹物证鉴定（车辆安全技术状况鉴定；交通设施安全技术状况鉴定；交通事故痕迹鉴定；车辆速度鉴定；交通事故痕迹物证综合鉴定），是河北省首家通过司法部司法鉴定研究所能力验证的司法鉴定机构。</br>
								<span style="margin-left: 30px;"></span>中心现有一支由司法鉴定人和鉴定人助理组成的精英团队，拥有先进的检测仪器、专业的实验室配置。成立八年来累计完成各类委托案件两万余件，为各级法院、仲裁解决案件审理中的技术事实判定难题提供诉讼证据，为公安交通管理部门确定事故成因、做出责任划分提供有力的支持；为保险公司应对保险欺诈及减损提供了客观的理赔依据。</br>
								<span style="margin-left: 30px;"></span>河北燕赵司法鉴定中心用最专业的人做最专业的事，用最专业的技术做最好的服务，应广大鉴定需求群体要求，开通线上案件咨询预约直通车服务，全面提升鉴定综合实力，打造区域性最广、专业性最强、采信率最高的司法鉴定中心。
								</p>

						</div>
						<div class="bottomContent_imgs">
							<img src="../../assets/images/yz1.png" alt="" style="height: 220px;">
							<img src="../../assets/images/wz_02.jpg" alt="" style="height: 220px;">
							<img src="../../assets/images/yz2.png" alt="" style="height: 220px;">
							<img src="../../assets/images/yz3.png" alt="" style="height: 220px;">
						</div>
						<p v-for="(item, index) in jdfw" :key="index" class="fwxmItem">{{item}}</p>
						<!-- <div class="line"></div>
						<div class="bottomWorditems">
							<p class="bottomWorditem">
								<img src="../../assets/images/arrow_down.png" alt="">
								· 河北冀通司法鉴定中心
							</p>
							<p class="bottomWorditem">
								<img src="../../assets/images/arrow_down.png" alt="">
								· 河北津实司法鉴定中心
							</p>
							<p class="bottomWorditem">
								<img src="../../assets/images/arrow_down.png" alt="">
								· 三河中裕司法鉴定中心
							</p>
						</div>
						<div class="bottomWorditems">
							<p class="bottomWorditem">
								<img src="../../assets/images/arrow_down.png" alt="">
								· 唐山宏基司法鉴定中心
							</p>
							<p class="bottomWorditem">
								<img src="../../assets/images/arrow_down.png" alt="">
								· 河北北方学院司法鉴定中心
							</p>
							<p class="bottomWorditem">
								<img src="../../assets/images/arrow_down.png" alt="">
								· 唐山物证司法鉴定中心
							</p>
						</div>
						<div class="bottomWorditems">
							<p class="bottomWorditem">
								<img src="../../assets/images/arrow_down.png" alt="">
								· 河北省工程质量司法鉴定中心
							</p>
							<p class="bottomWorditem">
								<img src="../../assets/images/arrow_down.png" alt="">
								· 河北盛唐司法鉴定中心
							</p>
							<p class="bottomWorditem">
								<img src="../../assets/images/arrow_down.png" alt="">
								· 三河中裕司法鉴定中心
							</p>
						</div> -->
					</div>

				</div>
			</main>
		</div>
</template>

<script>

import axios from 'axios'
import '../../assets/css/index.less'
export default {
	name: 'Pdf',
	components: {
	},
	data() {
		return {
			jdfw:[
				'鉴定服务项目',
				'机动车事故原因分析鉴定',
				'事故车辆速度鉴定',
				'数股车辆损失鉴定',
				'车辆安全技术性能鉴定',
				'事故痕迹检验鉴定'
			],
			fayuanName: '河南省高级人民法院',
			navActive: 5,
		};
	},
	methods: {
	},
	created(){

	},
	mounted() {
		let that = this;
	},
};
</script>

<style lang="less" scoped="scoped">
	.fyBox{
		width: 100%;
		height: 340px;
		box-sizing: border-box;
		background: url(../../assets/images/wuzheng_banner.png)no-repeat center;
		img{
			width: 100%;
			height: 300px;
			display: block;
			margin: 0 auto;
		}
	}
	.centerBox{
		width: 1134px;
		margin: 0 auto;
		overflow: hidden;
		box-sizing: border-box;
	}
	.topContent_word1{
		// width: 66px;
		height: 30px;
		float: left;
		line-height: 30px;
		border-bottom: 4px solid  #3DADC6;
	}
	.topContent_word2{
		margin-top: 12px;
		text-indent: 30px;
		width: 100%;
		float: left;
		text-align: justify;
		font-family: PingFangRegular;
		font-size: 16px;
		color: #000000;
		text-align: left;
		line-height: 28px;
	}

	.topContent{
		width: 100%;
		background: #fff;
		padding: 26px 0;
		box-sizing: border-box;
		overflow: hidden;
	}
	.bottomContent{
		width: 100%;
		background: #fff;
		padding: 20px;
		box-sizing: border-box;
		float: left;
		margin-top: 25px;
		padding-bottom: 60px;
	}
	.bottomContent_top{
		width: 100%;
		overflow: hidden;
		display: flex;
		    align-items: center;
		    margin-bottom: 15px;
		img{
			float: left;
		}
		.bottomContent_topWord{
			float: right;
			width: calc(100% - 350px);
			font-family: PingFangRegular;
			font-size: 16px;
			color: #000000;
			text-align: left;
			line-height: 28px;
			text-indent: 30px;
			text-align: justify;

		}
	}
	.bottomContent_imgs{
		width: 100%;
		overflow: hidden;
		margin-bottom: 20px;
		img{
			width: 23%;
			display: block;
			float: left;
			margin-right: 25px;
			&:last-of-type{
				margin-right: 0;
			}
		}
	}
	.fwxmItem{
		    /* width: 13%; */
		    padding: 0 10px;
		    height: 32px;
		    line-height: 32px;
		   background: #01458E;
		    border-radius: 5px;
		    text-align: center;
		    float: left;
		    font-size: 16px;
		    color: #fff;
		    margin-right: 15px;
		    box-sizing: border-box;
		    margin-bottom: 10px;

		&:first-of-type{
			background: none;
			color: #000;
		}
		&:last-of-type{
			margin-right: 0;
		}
	}
	.line{
		width: 100%;
		border-bottom: 2px dashed  #979797;
		margin:20px 0;
		float: left;
		margin-top: 40px;
	}
	.bottomWorditems{
		width: 100%;
		border-bottom: 1px dashed  #979797;
		overflow: hidden;
		.bottomWorditem{
			width: 33%;
			height: 47px;
			line-height: 47px;
			float: left;
			display: flex;
			align-items: center;
			img{
				float: left;
				margin-right: 10px;
			}
		}
	}
</style>
